/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextAlignCenterJustifyIcon32Regular = forwardRef('TextAlignCenterJustifyIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M5 6a1 1 0 0 0 0 2h22a1 1 0 1 0 0-2H5Z" }),
        React.createElement("path", { d: "M5 12a1 1 0 1 0 0 2h22a1 1 0 1 0 0-2H5Z" }),
        React.createElement("path", { d: "M5 24a1 1 0 1 0 0 2h22a1 1 0 1 0 0-2H5Z" }),
        React.createElement("path", { d: "M4 19a1 1 0 0 1 1-1h22a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Z" })));
});
